import React from 'react';

export default function Spinner({ fullscreen }) {
  const inner = (
    <div style={{ display: 'inline-block', width: 28, height: 28, border: '3px solid #e9ecef', borderTopColor: '#0f74b9', borderRadius: '50%', animation: 'spin 0.7s linear infinite' }}>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );
  if (fullscreen) return (
    <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{inner}</div>
  );
  return <div style={{ padding: 20, textAlign: 'center' }}>{inner}</div>;
}
